module.exports = __webpack_public_path__ + "static/media/police.880874bc.jpg";